import React from 'react';

import FacebookLogo from 'assets/svgs/social-icons/facebook.svg';
import GlassdoorLogo from 'assets/svgs/social-icons/glassdoor.svg';
import InstagramLogo from 'assets/svgs/social-icons/instagram.svg';
import LinkedinLogo from 'assets/svgs/social-icons/linkedin.svg';
import TwitterLogo from 'assets/svgs/social-icons/twitter.svg';
import Link from 'components/link/link';
import './footer.scss';

// ToDo: Move to own json files and import them here using GraphQL
const socialIcons = [
  {
    name: 'facebook',
    logo: FacebookLogo,
    url: 'http://www.facebook.com/lucidchart'
  },
  {
    name: 'twitter',
    logo: TwitterLogo,
    url: 'https://twitter.com/lucidchart'
  },
  {
    name: 'instagram',
    logo: InstagramLogo,
    url: 'https://www.instagram.com/lucidsoftware/'
  },
  {
    name: 'linkedIn',
    logo: LinkedinLogo,
    url: 'https://www.linkedin.com/company/lucidsoftware'
  },
  {
    name: 'glassdoor',
    logo: GlassdoorLogo,
    url:
      'http://www.glassdoor.com/Overview/Working-at-Lucid-Software-EI_IE636868.11,25.htm'
  }
];

const Footer = () => (
  <footer className="twelve-grid footer-container">
    <div className="footer-wrapper">
      <nav className="footer-left">
        <ul className="footer-nav-links unstyled">
          <li>
            <Link to="/careers">Careers</Link>
          </li>
          <li>
            <Link to="/careers/team/engineering">Engineering</Link>
          </li>
          <li>
            <Link to="/people">People</Link>
          </li>
          <li>
            <Link to="/newsroom">Newsroom</Link>
          </li>
          <li>
            <a href="https://www.lucidchart.com/pages/privacy">Privacy</a>
          </li>
        </ul>
      </nav>
      <div className="footer-right">
        <nav>
          <ul className="footer-social-icons unstyled">
            {socialIcons.map(icon => (
              <li key={icon.name}>
                <a href={icon.url}>
                  <img alt={icon.name} src={icon.logo} />
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <address>
          10355 S Jordan Gateway Suite 150
          <br />
          South Jordan, UT 84095
        </address>
        <p className="copy">
          <span aria-label="Copyright" role="img">
            &copy;
          </span>
          {`${new Date().getFullYear()} Lucid Software Inc.`}
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
